// extracted by mini-css-extract-plugin
export var wrapper = "blog-module--wrapper--d-i8_";
export var content = "blog-module--content--WPbtk";
export var postBorder = "blog-module--post-border--bwmWc";
export var postBorderHighlight = "blog-module--post-border-highlight--2NhyS";
export var post = "blog-module--post--BES3q";
export var header = "blog-module--header--plweS";
export var date = "blog-module--date--2nA_q";
export var description = "blog-module--description--3x8I7";